/* Aura Rise theme scripts: search, loader, cart drawer (Shopify AJAX Cart API), lightbox, welcome offer. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var money = function (cents) {
    var n = (cents || 0) / 100;
    return '$' + (Math.abs(n % 1) > 0.004 ? n.toFixed(2) : String(Math.round(n)));
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var cfg = window.AuraRise || {};
  var freeAt = cfg.freeShippingCents || 5000;
  var flatRate = cfg.flatRateCents || 800;

  /* ---------- page loader on product links ---------- */
  var loader = $('#ar-loader');
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-load]');
    if (!a || !loader || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    loader.hidden = false;
    setTimeout(function () { loader.hidden = true; }, 4000);
  });
  window.addEventListener('pageshow', function () { if (loader) loader.hidden = true; });

  /* ---------- search overlay ---------- */
  var sOvl = $('#ar-search');
  var sInput = $('#ar-search-input');
  var sOut = $('#ar-search-results');
  var sLine = $('#ar-search-line');
  var products = [];
  try { products = JSON.parse(($('#ar-products') || {}).textContent || '[]'); } catch (e) {}
  var TYPES = { bracelet: 'Bracelet', bracelets: 'Bracelet', cuff: 'Bracelet', cuffs: 'Bracelet', necklace: 'Necklace', necklaces: 'Necklace', lariat: 'Necklace', earring: 'Earring', earrings: 'Earring', hoops: 'Earring', ring: 'Ring', rings: 'Ring' };
  function runSearch() {
    var q = (sInput.value || '').trim();
    var toks = q.toLowerCase().split(/\s+/).filter(Boolean);
    if (!toks.length) { sOut.innerHTML = ''; sLine.hidden = true; return; }
    var found = products.filter(function (p) {
      var hay = (p.t + ' ' + p.type + ' ' + p.stones + ' ' + p.col + ' ' + p.tags).toLowerCase();
      return toks.every(function (t) { return TYPES[t] ? p.type === TYPES[t] : hay.indexOf(t) > -1; });
    });
    sLine.hidden = false;
    sLine.querySelector('span').textContent = found.length === 1 ? '1 piece for “' + q + '”' : found.length + ' pieces for “' + q + '”';
    sOut.innerHTML = found.length ? found.slice(0, 12).map(function (p) {
      return '<a class="card" data-load href="' + esc(p.u) + '"><div class="imgbox"><img class="card-img" loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.t) + '"></div>' +
        '<div class="card__row"><span class="card__name" style="font-size:15px">' + esc(p.t) + '</span><span class="serif card__price">' + esc(p.p) + '</span></div>' +
        '<div class="eyebrow" style="font-size:12px">' + esc(p.type) + (p.col ? ' · ' + esc(p.col) : '') + '</div></a>';
    }).join('') : '<p class="serif" style="margin:0;font-size:24px;font-style:italic;color:#5E4A42;grid-column:1/-1">Nothing by that name yet. Try “bracelet”, “turquoise”, “tassel” or “Caravan”.</p>';
  }
  function openSearch() { if (!sOvl) return; sOvl.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(function () { sInput.focus(); }, 30); }
  function closeSearch() { if (!sOvl) return; sOvl.hidden = true; document.body.style.overflow = ''; }
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', openSearch); });
  $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  if (sInput) sInput.addEventListener('input', runSearch);
  $$('[data-chip]').forEach(function (b) { b.addEventListener('click', function () { sInput.value = b.getAttribute('data-chip'); runSearch(); sInput.focus(); }); });

  /* ---------- cart drawer ---------- */
  var drawer = $('#ar-drawer'), shade = $('#ar-drawer-shade');
  var noteTimer = null;
  function ensureLaunch(c) { if (!cfg.launchOn || !cfg.launchCode || !c || !c.item_count || (c.discount_codes || []).length) return c; return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: cfg.launchCode }) }).then(function (r) { return r.ok ? r.json() : c; }).catch(function () { return c; }); } function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderCart(cart, justAdded) {
    if (!drawer) return;
    setCount(cart.item_count);
    $('[data-drawer-count]', drawer).textContent = cart.item_count;
    $('[data-drawer-added]', drawer).hidden = !justAdded;
    var empty = cart.item_count === 0;
    $('[data-drawer-empty]', drawer).hidden = !empty;
    $('[data-drawer-full]', drawer).hidden = empty;
    if (empty) return;
    $('[data-drawer-lines]', drawer).innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="drawer__line"><img src="' + esc(img) + '" alt="">' +
        '<div style="flex:1 1 auto;display:flex;flex-direction:column;gap:4px;min-width:0"><a href="' + esc(it.url) + '" style="font-size:15px;text-decoration:none">' + esc(it.product_title) + '</a>' +
        '<span class="eyebrow" style="font-size:11px">' + esc(it.product_type || '') + '</span>' +
        '<div class="qty"><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="Fewer">−</button><span style="color:#2B1915">' + it.quantity + '</span>' +
        '<button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="More">+</button>' +
        '<button type="button" class="linkbtn" data-qty="' + esc(it.key) + '" data-to="0" style="margin-left:8px">Remove</button></div></div>' +
        '<span class="serif" style="font-size:19px">' + money(it.original_line_price) + '</span></div>';
    }).join('');
    var sub = cart.original_total_price, disc = sub - cart.total_price;
    $('[data-sum-sub]', drawer).textContent = money(sub);
    var dRow = $('[data-sum-disc-row]', drawer);
    dRow.hidden = disc <= 0;
    if (disc > 0) {
      var titles = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
      cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && titles.indexOf(a.discount_application.title) < 0) titles.push(a.discount_application.title); }); });
      $('[data-sum-disc-label]', drawer).textContent = titles.join(' · ') || 'Discount';
      $('[data-sum-disc]', drawer).textContent = '− ' + money(disc);
    }
    $('[data-sum-ship]', drawer).textContent = cart.total_price >= freeAt ? 'Free U.S. shipping' : money(flatRate) + ' U.S. standard · free over ' + money(freeAt);
    $('[data-sum-total]', drawer).textContent = money(cart.total_price);
    var hint = $('[data-stack-hint]', drawer);
    var A = window.AuraRise || {};
    hint.textContent = !A.stackOn ? '' : (cart.item_count === 1 || cart.item_count === 2) ? 'Add ' + (cart.item_count === 1 ? 'two more pieces' : 'a third piece') + ' and all are ' + A.stack3 + '% off; the better saving applies.' : '';
    hint.hidden = !hint.textContent;
    var note = $('[data-cart-note]', drawer);
    if (note && document.activeElement !== note) note.value = cart.note || '';
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(ensureLaunch); }
  function openDrawer(justAdded) {
    fetchCart().then(function (c) { renderCart(c, justAdded); drawer.hidden = false; shade.hidden = false; document.body.style.overflow = 'hidden'; });
  }
  function closeDrawer() { drawer.hidden = true; shade.hidden = true; document.body.style.overflow = ''; }
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openDrawer(false); } }); });
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-qty'), quantity: parseInt(b.getAttribute('data-to'), 10) }) })
        .then(function (r) { return r.json(); }).then(function (c) { renderCart(c, false); });
    });
    var note = $('[data-cart-note]', drawer);
    if (note) note.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
      }, 500);
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-add]') || !drawer) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    var err = f.querySelector('[data-add-error]');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) { if (err) { err.textContent = res.j.description || 'This piece could not be added.'; err.hidden = false; } return; }
        if (err) err.hidden = true;
        openDrawer(true);
      }).catch(function () { if (btn) btn.disabled = false; f.submit(); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    if (sOvl && !sOvl.hidden) closeSearch();
    if (lb && !lb.hidden) closeLb();
  });

  /* ---------- product lightbox ---------- */
  var lb = $('#ar-lightbox'), lbImgs = [], lbIdx = 0;
  try { lbImgs = JSON.parse(($('#ar-gallery') || {}).textContent || '[]'); } catch (e) {}
  function showLb() {
    var it = lbImgs[lbIdx]; if (!it) return;
    var img = $('img', lb); img.src = it.src; img.alt = it.alt;
    $('[data-lb-count]', lb).textContent = (lbIdx + 1) + ' / ' + lbImgs.length;
    $('.lightbox__stage', lb).classList.remove('zoom');
    $('[data-lb-zoom]', lb).textContent = '+ Zoom in';
  }
  function closeLb() { lb.hidden = true; document.body.style.overflow = ''; }
  if (lb) {
    $$('[data-lb-open]').forEach(function (b) { b.addEventListener('click', function () { lbIdx = parseInt(b.getAttribute('data-lb-open'), 10) || 0; showLb(); lb.hidden = false; document.body.style.overflow = 'hidden'; }); });
    $('[data-lb-close]', lb).addEventListener('click', closeLb);
    $('[data-lb-prev]', lb).addEventListener('click', function () { lbIdx = (lbIdx + lbImgs.length - 1) % lbImgs.length; showLb(); });
    $('[data-lb-next]', lb).addEventListener('click', function () { lbIdx = (lbIdx + 1) % lbImgs.length; showLb(); });
    var zoom = function () { var st = $('.lightbox__stage', lb); var z = st.classList.toggle('zoom'); $('[data-lb-zoom]', lb).textContent = z ? '− Zoom out' : '+ Zoom in'; };
    $('[data-lb-zoom]', lb).addEventListener('click', zoom);
    $('.lightbox__stage img', lb).addEventListener('click', zoom);
  }

  /* ---------- welcome offer ---------- */
  var offer = $('#ar-offer');
  if (offer) {
    var posted = offer.getAttribute('data-posted') === 'true';
    var close = function () { offer.hidden = true; store.set('ar_offer', 'closed'); };
    $$('[data-offer-close]', offer).forEach(function (b) { b.addEventListener('click', close); });
    if (posted) { offer.hidden = false; store.set('ar_offer', 'joined'); }
    else if (!store.get('ar_offer')) setTimeout(function () { offer.hidden = false; }, cfg.offerDelay || 4000);
  }

  /* ---------- Wishlist (kept in this browser) ---------- */
  var WK = 'ar_wishlist';
  function wishGet() { try { var v = JSON.parse(store.get(WK) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function wishPut(a) { store.set(WK, JSON.stringify(a)); }
  function wishPaint() {
    var w = wishGet();
    $$('[data-wish-count]').forEach(function (el) { el.textContent = w.length; });
    $$('[data-wish]').forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-wish')) > -1;
      b.textContent = on ? 'Saved to wishlist ♥' : 'Add to wishlist';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-wish'), w = wishGet(), i = w.indexOf(h);
      if (i > -1) w.splice(i, 1); else w.push(h);
      wishPut(w); wishPaint(); return;
    }
    var r = e.target.closest && e.target.closest('[data-wish-remove]');
    if (r) { e.preventDefault(); wishPut(wishGet().filter(function (x) { return x !== r.getAttribute('data-wish-remove'); })); wishPaint(); renderWishlist(); }
  });
  window.addEventListener('storage', function (e) { if (e.key === WK) { wishPaint(); renderWishlist(); } });
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderWishlist() {
    var box = $('[data-wish-list]'), empty = $('[data-wish-empty]');
    if (!box) return;
    var w = wishGet();
    if (!w.length) { box.hidden = true; box.innerHTML = ''; if (empty) empty.hidden = false; return; }
    Promise.all(w.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var items = list.filter(Boolean);
      if (empty) empty.hidden = items.length > 0;
      box.hidden = items.length === 0;
      box.innerHTML = items.map(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=720' : p.featured_image + '?width=720') : '';
        var sku = (p.variants && p.variants[0] && p.variants[0].sku) || '';
        var num = sku.indexOf('AR') === 0 ? sku.slice(2, 4) : '';
        return '<div class="wish-card"><a class="card" href="' + esc(p.url) + '"><div class="imgbox">' +
          (img ? '<img class="card-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="720" height="900">' : '') +
          (num ? '<span class="serif card__num">' + esc(num) + '</span>' : '') +
          (p.available ? '' : '<span class="badge" style="top:auto;bottom:10px">Sold out</span>') +
          '</div><div class="card__row"><span class="card__name">' + esc(p.title) + '</span><span class="serif card__price">' + money(p.price) + '</span></div></a>' +
          '<button type="button" class="linkbtn" data-wish-remove="' + esc(p.handle) + '">Remove</button></div>';
      }).join('');
    });
  }
  wishPaint(); renderWishlist();

  /* ---------- Contact form: carry the piece over from "Have a question?" ---------- */
  (function () {
    var ta = $('[data-contact-message]');
    if (!ta || ta.value) return;
    var m = /[?&]piece=([^&]+)/.exec(location.search);
    if (m) { try { ta.value = 'About ' + decodeURIComponent(m[1].replace(/\+/g, ' ')) + ': '; } catch (e) {} }
  })();

  /* ---------- Launch code: applied automatically once per visitor (Shopify checks the 100-use limit) ---------- */
  (function () {
    if (!cfg.launchOn || !cfg.launchCode) return;
    return; /* launch code now applied to the cart by ensureLaunch() */
    fetch('/discount/' + encodeURIComponent(cfg.launchCode), { credentials: 'same-origin', redirect: 'follow' })
      .then(function () { store.set('ar_launch', cfg.launchCode); }).catch(function () {});
  })();
})();
